
/* eslint-disable jsx-a11y/label-has-associated-control , no-prototype-builtins, no-console,
  react/jsx-boolean-value,
  jsx-a11y/no-redundant-roles,
  jsx-a11y/no-noninteractive-element-to-interactive-role,
   jsx-a11y/role-supports-aria-props
*/ 
import React, { useEffect, useMemo, useState } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import styles from './View.Style'
import { Container } from '@material-ui/core'
import * as Yup from 'yup';

import Loading from 'components_newui/Loading';
import Formbuilder from 'components_newui/formBuilder/View'



/**
 * Compute sum of numeric weights safely.
 */
const computeTotalWeight = (items = []) =>
  items
    .filter((item) => Object.prototype.hasOwnProperty.call(item || {}, 'weight'))
    .reduce((sum, item) => sum + Number(item?.weight || 0), 0)

/**
 * Determine if a primitive value looks like a finite number.
 */
const isFiniteNumber = (v) => {
  const n = Number(v)
  return Number.isFinite(n)
}


/** ---------- Utils ---------- */
// const computeTotalWeight = (items = []) =>
//   items
//     .filter((item) => Object.prototype.hasOwnProperty.call(item, 'weight'))
//     .reduce((sum, item) => sum + Number(item?.weight || 0), 0)

/** ---------- Validation ---------- */
const validationSchema = Yup.object().shape({
  templateName: Yup.string()
    .min(3,'Minimum 3 characters')
    .max(100, 'Maximum 100 characters')
    .required('Template Name is required')
    .trim()
    .matches(
      /^[a-zA-Z0-9_ #!?|]*$/,
      'Only letters, numbers, spaces, underscore (_), hash (#), exclamation (!), question mark (?), and pipe (|) are allowed'
    ),
  // enforce business rule for total weight
  totalWeight: Yup.number()
    .oneOf([100], 'Total weight must equal 100'),
});

const UpdateScorecardTemplate = (props) => {
  const  {
    classes,
    match,
    myEmail,
    getScorecardTemplateEditIDFn,
    editIdScorecardTemplateLoading,
    editIdScorecardTemplateData,
    putScorecardTemplateEditFn,
    updateScorecardTemplateLoading,
  } = props || {}

  const scorecardTemplateId = match?.params?.id ? Number(match.params.id) : null;


  // Extract values safely from server payload
  const {
    activeTemplate,
    scoreCardJson,
    templateName,
    weightCount,
  } = editIdScorecardTemplateData || {}

  // Parse server JSON defensively
  let serverJsonArr = []
  try {
    if (scoreCardJson?.value) {
      serverJsonArr = JSON.parse(scoreCardJson.value)
    }
  } catch (error) {
    console.error("Invalid JSON:", error)
  }

  const [errors, setErrors] = useState({})
  const [isFormValid, setIsFormValid] = useState(false)
  const [initialized, setInitialized] = useState(false)

  // Source of truth for the editable list coming from Formbuilder
  const [scoreCardTemplatebuilderFormDataChildToParent, setScoreCardTemplatebuilderFormDataChildToParent] = useState(serverJsonArr)
  const [scorecardJSONRowFormData, setScorecardJSONRowFormData] = useState([])

  // Derived total weight (always recomputed from the list)
  const [totalWeight, setTotalWeight] = useState(
    typeof weightCount === 'number' ? weightCount : computeTotalWeight(serverJsonArr)
  )

  const [scorecardTemplateValue, setScorecardTemplateValue] = useState({
    templateName: templateName || '',
    templateActive: !!activeTemplate,
    totalWeight,
    templateJson: serverJsonArr
  })


  // console.log("1st sender initialized", initialized)
  // console.log("1st sender on load data", editIdScorecardTemplateData)
  // console.log("1st sender on recive form builder data", scoreCardTemplatebuilderFormDataChildToParent)
  // console.log("1st sender on recive form builder data", scorecardJSONRowFormData)
  // console.log("1st sender on scorecardTemplateValue", scorecardTemplateValue)


  /** Fetch the template by id on mount */
  useEffect(() => {
    if (scorecardTemplateId !== null) {
      getScorecardTemplateEditIDFn(scorecardTemplateId)
    }
  }, [scorecardTemplateId])

  /** Seed form state only once when server data arrives */
  useEffect(() => {
    // if (
    //   editIdScorecardTemplateData &&
    //   Object.keys(editIdScorecardTemplateData).length > 0 &&
    //   !initialized
    // ) {
      const parsedJson = Array.isArray(serverJsonArr) ? serverJsonArr : []
      const initialTotal =
        typeof weightCount === 'number' ? weightCount : computeTotalWeight(parsedJson)

      setScoreCardTemplatebuilderFormDataChildToParent(parsedJson)
      setTotalWeight(initialTotal)

      setScorecardTemplateValue({
        templateName: templateName || '',
        templateActive: !!activeTemplate,
        totalWeight: initialTotal,
        templateJson: parsedJson,
      })

      // setInitialized(true)
    // }
  }, [editIdScorecardTemplateData])

  /** Keep total weight in sync with the child list */
  useEffect(() => {
    const t = computeTotalWeight(scoreCardTemplatebuilderFormDataChildToParent)
    setTotalWeight(t)

    // also keep the master value in sync
    setScorecardTemplateValue((prev) => ({
      ...prev,
      templateJson: scoreCardTemplatebuilderFormDataChildToParent,
      totalWeight:t,
    }))
  }, [scoreCardTemplatebuilderFormDataChildToParent])

  /** Validate on every change */
  useEffect(() => {
    const validateForm = async () => {
      try {
        await validationSchema.validate(scorecardTemplateValue, { abortEarly: false })
        setErrors({})
        setIsFormValid(true)
      } catch (err) {
        const formattedErrors = {}
        if (err?.inner?.length) {
          err.inner.forEach((error) => {
            formattedErrors[error.path] = error.message
          })
        } else if (err?.path) {
          formattedErrors[err.path] = err.message
        }
        setErrors(formattedErrors)
        setIsFormValid(false)
      }
    }
    validateForm()
  }, [scorecardTemplateValue])

  /** Handlers */
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target
    setScorecardTemplateValue(prevState => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value
    }))
  }

  const handleSave = async () => {
    try {
      // validate both name & totalWeight (must be 100)
      await validationSchema.validate(scorecardTemplateValue, { abortEarly: false })

      const jsonDataEditUpdate =
      Array.isArray(scorecardJSONRowFormData) && scorecardJSONRowFormData.length > 0
        ? scorecardJSONRowFormData
        : serverJsonArr;
        
      const payload = {
        ...scorecardTemplateValue,
        templateJson: JSON.stringify(jsonDataEditUpdate)  ,

        totalWeight, // derived from the array to avoid drift
      }

      await putScorecardTemplateEditFn(myEmail, payload, scorecardTemplateId)
    } catch (error) {
      console.error("Error during save:", error)
    }
  }

  if (editIdScorecardTemplateLoading) {
    return <Loading />
  }

  return (
    <Container maxWidth="lg"> {/* replaced invalid fullWidth prop */}
      <div className={classes.createscorecardwrap}>
        <div className={classes.headingwrp}>
          <h2 className={classes.title}>Edit Scorecard Template</h2>
        </div>

        <div className={classes.formbox}>
          <div className='block'>
            <div className={classes.fieldbox}>
              <label htmlFor='templateName' className={classes.labels}>Template Name</label>
              <input
                className={classes.inputs}
                value={scorecardTemplateValue.templateName}
                type='text'
                name='templateName'
                id='templateName'
                onChange={handleChange}
                required
                aria-required={true}
              />
              {errors.templateName && <p className={classes.error}>{errors.templateName}</p>}
            </div>
          </div>

          <OverAllWeight
            scorecardUpdateListdata={scoreCardTemplatebuilderFormDataChildToParent}
            classes={classes}
          />
          {errors.totalWeight && (
            <p className={classes.error} style={{ marginTop: 8 }}>{errors.totalWeight}</p>
          )}
        </div>

        <h3>Edit your template</h3>
        <Formbuilder
          isLoading={updateScorecardTemplateLoading}
          onSave={handleSave}
          btnDisable={!isFormValid}            // now accounts for totalWeight rule too
          mode='edit'
          sendJsonArrOfObjDataToChild={serverJsonArr}
          setScoreCardTemplatebuilderFormData={setScoreCardTemplatebuilderFormDataChildToParent}
          setScorecardJSONRowFormData={setScorecardJSONRowFormData}
        />
      </div>
    </Container>
  )
}

export default withStyles(styles)(UpdateScorecardTemplate)


const OverAllWeight = ({
  scorecardUpdateListdata,
  classes,
  requiredTotal = 100,
  title = 'Overall scoring weights',
}) => {
  // Always treat incoming data defensively
  const incoming = Array.isArray(scorecardUpdateListdata) ? scorecardUpdateListdata : []

  // Filter to items that explicitly have the "weight" property
  const rows = useMemo(
    () => incoming.filter((obj) => Object.prototype.hasOwnProperty.call(obj || {}, 'weight')),
    [incoming]
  )

  // Compute numeric total and diagnostics
  const { total, invalidRowsCount, nonNumericRows } = useMemo(() => {
    let invalid = 0
    const nonNumeric = []

    rows.forEach((r, idx) => {
      if (!isFiniteNumber(r?.weight)) {
        invalid += 1
        nonNumeric.push(idx)
      }
    })

    return {
      total: computeTotalWeight(rows),
      invalidRowsCount: invalid,
      nonNumericRows,
    }
  }, [rows])

  const okTotal = total === requiredTotal
  const remaining = requiredTotal - total
  const totalColor = okTotal ? 'green' : 'red'

  return (
    <section
      className={classes.overallWeight}
      aria-labelledby="overall-weight-title"
      role="region"
    >
      <p id="overall-weight-title" className={classes.labels}>
        {title}
      </p>

      <div
        className={classes.overallBox}
        role="table"
        aria-label="Scorecard weight summary"
      >
        <div className={classes.overallHeading} role="rowgroup">
          <div className={classes.overallHeadingRow} role="row">
            <h4 className={classes.heading} role="columnheader">Question</h4>
            <h4 className={classes.heading} role="columnheader">Weight</h4>
          </div>
        </div>

        <div role="rowgroup">
          {rows.map((item, index) => {
            const key = item?.id ?? `${item?.label ?? 'row'}-${index}`
            const label = item?.label ?? `Row ${index + 1}`
            const weight = item?.weight
            const numeric = isFiniteNumber(weight)

            return (
              <div key={key} className={classes.overallWeightRow} role="row">
                <h4 className={classes.heading} role="cell">{label}</h4>
                <p
                  className={classes.heading}
                  role="cell"
                  aria-invalid={!numeric}
                  style={{
                    color: numeric ? undefined : 'darkorange',
                    fontStyle: numeric ? 'normal' : 'italic',
                  }}
                >
                  {numeric ? Number(weight) : `Invalid (${String(weight)})`}
                </p>
              </div>
            )
          })}
        </div>

        {/* Total row */}
        <div className={classes.overallWeightRow} role="row">
          <h4 className={classes.heading} role="cell">Total Weight</h4>
          <p
            className={classes.heading}
            role="cell"
            aria-live="polite"
            aria-atomic="true"
            style={{ color: totalColor, fontWeight: 'bold' }}
          >
            {total}
          </p>
        </div>

        {/* Remaining budget indicator */}
        {!okTotal && (
          <div className={classes.overallWeightRow} role="row">
            <h4 className={classes.heading} role="cell">Remaining</h4>
            <p
              className={classes.heading}
              role="cell"
              style={{ color: remaining > 0 ? 'red' : 'darkred', fontWeight: 600 }}
            >
              {remaining}
            </p>
          </div>
        )}
      </div>

      {/* Validation summary */}
      {!okTotal && (
        <p
          role="status"
          aria-live="assertive"
          style={{ color: 'red', marginTop: 10 }}
        >
          Total weight must equal {requiredTotal}. Current total: {total}
          {invalidRowsCount > 0 && (
            <>
              {' '}
              • {invalidRowsCount} row{invalidRowsCount > 1 ? 's' : ''} have non-numeric or invalid weights.
            </>
          )}
        </p>
      )}
    </section>
  )
}


